module.exports = __webpack_public_path__ + "static/media/1_simplex_A_yellow_square.a7a320cf.png";